export const lightspeed = {
  seo: {
    title: 'Lightspeed integration | Bistroo',
    description: 'Connect your Lightspeed POS to Bistroo. Online orders automatically arrive as POS tickets — no manual retyping, no errors.',
  },
  hero: {
    category: 'POS system',
    description: 'Combine Bistroo\'s modern ordering solutions with Lightspeed\'s leading POS system. One integration, infinite convenience for your restaurant operations.',
    badge: 'Official integration partner',
    check_1: 'No obligation and cancel monthly',
    check_2: 'Set up in minutes',
  },
  about: {
    title: 'What does Lightspeed do?',
    p1: 'Lightspeed Restaurant is a cloud POS system built specifically for the restaurant industry. It provides real-time insight into your revenue, inventory management and staff scheduling — all from one dashboard, on any device. Thousands of hospitality businesses in the Netherlands and Belgium rely on Lightspeed.',
    p2: 'With the Bistroo connection, online orders from your webshop arrive directly as POS transactions in Lightspeed. Your team doesn\'t need to retype anything; everything runs automatically. Fewer errors, less stress and a smoother operation during the busiest peak periods.',
    benefits_title: 'What does the connection deliver?',
    benefits: [
      'Online orders land automatically in your Lightspeed POS',
      'Menu changes in Bistroo are synchronized',
      'Delivery and pickup times are passed on as instructions',
      'Real-time revenue reporting across all channels combined',
      'No double management: one system for POS and webshop',
    ],
  },
  wordcloud_title: 'Lightspeed at a glance',
  wordcloud: ['Cloud POS', 'Hospitality POS', 'Table management', 'Inventory management', 'POS tickets', 'Real-time reporting', 'Cloud-based', 'Order flows', 'Automation', 'Menu', 'API integration', 'Kitchen printing', 'Revenue analysis', 'Multi-location', 'Hospitality management software'],
  usp: {
    heading: 'Everything you need, perfectly integrated',
    subtitle: 'Powerful features that work together seamlessly to streamline your restaurant operations',
    items: [
      { icon: 'bi-lightning-charge-fill', title: 'Real-time synchronization', text: 'Orders, menu, inventory and sales data instantly synchronized between Bistroo and Lightspeed POS.' },
      { icon: 'bi-bar-chart-fill', title: 'Manual time confirmation', text: 'Unique to this integration is the ability to manually assign a time to pickup or delivery orders.' },
      { icon: 'bi-clock-fill', title: 'Time savings & peak management', text: 'Eliminate manual data entry and never get overwhelmed during peak hours with Bistroo\'s smart time slot algorithm.' },
      { icon: 'bi-people-fill', title: 'Pre-orders, as they should be', text: 'Orders before the restaurant opens, but always printed upon opening on the day of delivery.' },
      { icon: 'bi-printer-fill', title: 'Seamless integration with the kitchen', text: 'Print or display webshop orders directly via Lightspeed in your kitchen, as usual.' },
      { icon: 'bi-check-circle-fill', title: 'No administrative hassle', text: 'The administration of your online webshop orders directly in your end-of-day report via the POS.' },
    ],
  },
  partnership: {
    title: 'Integration built for scale',
    subtitle: 'Our partnership brings together the best of both worlds: Bistroo\'s innovative ordering technology and Lightspeed\'s leading POS system infrastructure.',
    visual_bistroo: 'Bistroo Webshop',
    visual_bistroo_sub: 'Orders & Management',
    visual_lightspeed: 'Lightspeed POS',
    visual_lightspeed_sub: 'POS System',
    visual_status: 'Connected & Synchronized',
  },
  setup: {
    heading: 'How to connect Lightspeed to Bistroo',
    steps: [
      'Log in to your Bistroo Merchant Portal and go to Settings.',
      'Open the Integrations tab and click on Lightspeed.',
      'Log in with your Lightspeed account and authorize the connection via OAuth.',
      'Link your menu categories to the correct Lightspeed departments.',
      'Process a test order — the ticket will appear directly in your POS.',
    ],
  },
  faq: {
    items: [
      { q: 'Which version of Lightspeed do I need?', a: 'The Bistroo connection works with Lightspeed Restaurant (K-Series). Make sure your subscription includes API access; this is the case with most paid Lightspeed plans.' },
      { q: 'Are menu changes automatically synchronized?', a: 'Yes. When you add or update a product in Bistroo, this is automatically passed on to Lightspeed. In reverse, you can also import changes from Lightspeed into Bistroo.' },
      { q: 'Can I connect multiple locations?', a: 'Certainly. If you have multiple venues, you can link a separate Bistroo webshop per location to the relevant Lightspeed point of sale.' },
      { q: 'What happens if the internet connection drops?', a: 'Bistroo stores orders in the cloud. As soon as the connection is restored, pending orders are automatically forwarded to Lightspeed.' },
      { q: 'Is the Lightspeed connection included in my Bistroo subscription?', a: 'Yes, the connection is part of your standard Bistroo subscription. There are no additional installation costs.' },
    ],
  },
  cta: {
    title: 'Ready to try it for free?',
    subtitle: 'Start today and experience how Bistroo and Lightspeed work together for your restaurant. No setup costs, cancel monthly.',
    button_primary: 'Get started for free',
    button_secondary: 'Schedule a demo',
    footer_text: 'Set up in less than 10 minutes · Cancel at any time',
  },
}
